import { extractElementStyling } from '@/integrations/crystallize/helpers/element-styling-piece-helper';
import { PromotionItem } from './types';

type RawComponent = {
  id: string;
  name?: string;
  content?: {
    __typename?: string;
    text?: string;
    components?: any[];
    [key: string]: any;
  } | null;
};

type RawCatalogueItem = {
  id?: string;
  shape?: { identifier?: string };
  shapeIdentifier?: string;
  components?: RawComponent[];
};

function parseRawComponents(components: RawComponent[]): Record<string, unknown> {
  const parsed: Record<string, unknown> = {};
  components.forEach((component) => {
    if (component.content) {
      parsed[component.id] = component.content;
    }
  });
  return parsed;
}

export function extractPromotionItems(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  catalogueComponents: any[] | undefined,
  positionKey: string,
): PromotionItem[] {
  if (!catalogueComponents) {
    return [];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const positionComponent = catalogueComponents.find((c: any) => c.id === positionKey);
  if (!positionComponent?.content?.items) {
    return [];
  }

  return positionComponent.content.items
    .map((item: RawCatalogueItem) => {
      const shapeIdentifier = item.shape?.identifier || item.shapeIdentifier;
      if (!shapeIdentifier || !item.components || !item.id) {
        return null;
      }

      const parsedComponents = parseRawComponents(item.components);
      const elementStyling = extractElementStyling(parsedComponents);

      return {
        id: item.id,
        shapeIdentifier,
        components: parsedComponents,
        elementStyling,
      } satisfies PromotionItem;
    })
    .filter(Boolean) as PromotionItem[];
}
